var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.comName,{tag:"component",attrs:{"header":_vm.header,"ruleMap":_vm.ruleMap,"rankType":_vm.rankType,"types":_vm.types}},[_vm._t("list",null,{"hideType":_vm.hideType})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }